<template>
  <blockquote class="quote-block" :class="{ selected }" :style="quoteStyle">
    <MailVariableTextField
      :value="block.text || ''"
      multiline
      placeholder="Zitat…"
      rows="2"
      auto-grow
      dense
      hide-details
      flat
      solo
      background-color="transparent"
      field="line"
      :variables="variables"
      :tenant="tenant"
      @input="onText"
    />
    <footer v-if="block.cite" class="mt-1 text-caption">
      — {{ block.cite }}
    </footer>
  </blockquote>
</template>

<script>
import MailVariableTextField from "@/components/Mail/MailVariableTextField.vue";

export default {
  name: "QuoteBlock",
  components: { MailVariableTextField },
  props: {
    block: { type: Object, required: true },
    variables: { type: Array, default: () => [] },
    tenant: { type: Object, default: () => ({}) },
    selected: { type: Boolean, default: false },
  },
  computed: {
    quoteStyle() {
      return {
        textAlign: this.block.align || "left",
        color: this.block.color || "#555",
        fontStyle: "italic",
      };
    },
  },
  methods: {
    onText(v) {
      this.$emit("update", { ...this.block, text: v });
    },
  },
};
</script>

<style scoped>
.quote-block {
  padding: 8px 16px;
  margin: 0;
  border-left: 4px solid #cccccc;
  background: white;
  border-radius: 4px;
}
.quote-block.selected {
  outline: 2px solid var(--v-primary-base);
}
</style>
